import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.upcase);
  }

  upcase(event) {
    event.target.value = event.target.value.toUpperCase();
  }
}
